import React, { ReactElement, useState } from "react";
import { Drawer, ConfigProvider } from "antd";
import customizeTheme from "components/customize-theme";
import Icons from "components/icons";

interface IDrawerStandartProps
{
    modalButton?: ReactElement;
    showModal?: boolean;
    setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
    extraClass?: string;
    disabled?: boolean;
    width?: number;
    onCancel?: () => void;
    children: ReactElement | ReactElement[];
}

const DrawerStandart = ({
    modalButton,
    showModal: parentShowModal,
    setShowModal: parentSetShowModal,
    extraClass = "",
    disabled = false,
    width = 450,
    onCancel = () => { },
    ...props
}: IDrawerStandartProps) =>
{
    const [ showModal, setShowModal ] = useState(false);
    const isControlled =
        typeof parentShowModal !== "undefined" &&
        typeof parentSetShowModal !== "undefined";

    const setVisible = (visible: boolean) =>
    {
        if (isControlled) {
            parentSetShowModal(visible);
        } else {
            setShowModal(visible);
        }
    };

    const handleClose = () =>
    {
        setVisible(false);
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <>
            {modalButton && React.cloneElement(modalButton, {
                disabled,
                onClick: () => setVisible(true),
            })}
            <Drawer
                className={`drawer-standard ${extraClass}`}
                open={isControlled ? parentShowModal : showModal}
                width={width}
                placement="right"
                closeIcon={<Icons.Close />}
                onClose={handleClose}
                title={null}
                footer={null}
            >
                <ConfigProvider theme={customizeTheme.LightTheme()}>
                    {Array.isArray(props.children)
                        ? props.children.map((child, index) =>
                            React.cloneElement(child, {
                                key: index,
                                action: handleClose,
                                showModal: isControlled ? parentShowModal : showModal,
                            })
                        )
                        : React.cloneElement(props.children, {
                            action: handleClose,
                        })}
                </ConfigProvider>
            </Drawer>
        </>
    );
};

export default DrawerStandart;
